(function () {
    'use strict';
    angular.module('emarket.main.post').controller('ProductController', function () {
    });
}());
